"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
const CloseButtonRoot = (0, _material.styled)(_IconButton.default)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  margin: theme.spacing(2)
}));
const CloseButton = ({
  ariaLabel,
  className,
  handleClick,
  variant,
  color,
  size
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(CloseButtonRoot, {
  variant: variant,
  color: color,
  size: size,
  className: className,
  "aria-label": ariaLabel,
  onClick: handleClick,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
    fontSize: "inherit",
    color: "inherit"
  })
});
exports.CloseButton = CloseButton;
